// extracted by mini-css-extract-plugin
export default {"bar":"MethodSwitcher_bar__5NRK7","option":"MethodSwitcher_option__77ko2","optionActive":"MethodSwitcher_optionActive__srqZB"};